import { useState, useEffect } from 'react';
import { HostBackend } from '../../../../Routes/HostBackend.js';
/* document */
import { Text } from '../../Form/Inputs/Text.js';
import { Select } from '../../Form/Inputs/Select.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const Experiment = (props) => {
    const { el } = props;
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const [choosers, setChoosers] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasChoosers = await fetch(`${backend}/admin/choosers/experiment`, {
                method: 'GET', headers: { 'Authorization': token, 'Content-Type': 'application/json' }
            });
            const choosers = await datasChoosers.json();
            setChoosers(choosers);
        };
        fetchData();
    }, [backend, token]);
    return (
        <>
            <Select name="id_serie" choosers={choosers.serie} value={el ? el.id_serie : ''} />
            <Select name="id_author" choosers={choosers.author} value={el ? el.id_author : ''} />
            <Select name="id_description" choosers={choosers.describe} value={el ? el.id_description : ''} />
            <Text name="name" value={el ? el.name :''} />
            <Text name="slug" value={el ? el.slug : ''} />
            <Text name="number" value={el ? el.number : ''} />
            <Text name="route" value={el ? el.route : ''} />
            <Hidden name="id" value={el ? el.id : ''} />
        </>
    )
}